function generateSrcSet(url, widths) {
  return widths.map((width) => `${url}&width=${width} ${width}w`).join(', ')
}

const IMAGE_WIDTHS = [320, 480, 560, 640, 720, 960]

// TODO: Be able to pass sizes explcitly from outside the card component,
// so that the srcset fetches the right product
// Right now, just guarnatees not to use 100% width asset

export function ResultImage({ result, children }) {
  return (
    <div className="bg-brand-beige-dark relative h-full w-full overflow-hidden border-0">
      {result?.images?.length > 3 ? (
        <>
          <img
            className="absolute inset-0 h-full w-full object-cover object-bottom"
            srcSet={generateSrcSet(result.images[3].src, IMAGE_WIDTHS)}
            sizes="50vw"
            alt={result.images[3].alt}
          />
          <img
            className="absolute inset-0 h-full w-full object-cover object-bottom transition-all sm:group-hover/card:opacity-0"
            srcSet={generateSrcSet(result.images[0].src, IMAGE_WIDTHS)}
            sizes="50vw"
            alt={result.images[0]?.alt ?? ''}
          />
        </>
      ) : result.images?.length > 0 ? (
        <img
          className="absolute inset-0 h-full w-full object-cover object-bottom"
          srcSet={generateSrcSet(result.images[0]?.src ?? '', IMAGE_WIDTHS)}
          sizes="50vw"
          alt={result.images[0]?.alt ?? ''}
        />
      ) : null}
      {children}
    </div>
  )
}
